import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router';
import { getSession, processNumAndComma, isRealObject, valdiatePage, processNum, processStr } from '../../global';
import { searchConsignment_2, SingleConsignmentTracking } from '../../services/reportservice';
import { setLoading } from '../../redux/appSlice';
import CNInfo from './cninfo';
import { useDispatch } from 'react-redux';

const Tracking = ({props}) => {
    const dispatch = useDispatch();
    const cnInfo = props?.location?.state || {};

    const history = useHistory();
    const [cn, setcn] = useState('');
    const [consigneePhone, setConsigneePhone] = useState('');
    const [orderRef, setOrderRef] = useState('');

    const [data, setData] = useState([]);


    useEffect(() => {
            const searchCn = async (cn) => {
                const accounts = [...new Set(getSession('subaccounts').map(x => x.accountNo))];
                
                try {
                    dispatch(setLoading({ data: true }));
                    let cnResult = await SingleConsignmentTracking({ Consignments: cn, AccountNo: accounts, OrderNo: orderRef, PhoneNo: consigneePhone })
                    //let cnResult = await searchConsignment_2(e)
                    dispatch(setLoading({ data: false }));

                    if (cnResult.sts === true && cnResult.tracking_Details.length > 0) {
                        const mappedArray = cnResult.tracking_Details.map(e => {
                            return {
                                ...e,
                                result: 'AVAILABLE'
                            }
                        })
                        setData(mappedArray);
                    } else {
                        setData(prev => { return [...prev, {cn: cn, result:  'NOTAVAILABLE'}] })
                    }
                    
                } catch (c) {
                    setData(prev => { return [...prev, { result: 'UNKNOWNERROR', error: `Something went wrong with this consignment ${c}` }] })
                }
            }
            const cn = sessionStorage.getItem('cn') || cnInfo.cn;
            if (cn) {
                setcn(cn);
                searchCn(cn);
            }
            sessionStorage.removeItem('cn');
       
    }, []);

    const onSearch = async () => {
        setData([])
        if (!cn && !consigneePhone && !orderRef) {
            alert('Enter Consignment No OR Phone No OR Order Ref No');
            return;
        }

        if (!!consigneePhone.length && !(consigneePhone.length >= 10  && consigneePhone.length  <= 11)) {
            alert('Phone No is Invalid');
            return false;
        }
        
        if (!!orderRef.length && orderRef.length > 20) {
            alert('Order Ref No is Invalid');
            return false;
        }

        const accounts = [...new Set(getSession('subaccounts').map(x => x.accountNo))];
        if (cn.length > 0) {
                if (cn.length >= 11 && cn.length <= 15) {
                    try {
                        dispatch(setLoading({ data: true }));
                        let cnResult = await SingleConsignmentTracking({ Consignments: cn, AccountNo: accounts, OrderNo: orderRef, PhoneNo: consigneePhone })
                        //let cnResult = await searchConsignment_2(e)
                        dispatch(setLoading({ data: false }));

                        if (cnResult.sts === true && cnResult.tracking_Details.length > 0) {
                            const mappedArray = cnResult.tracking_Details.map(e => {
                                return {
                                    ...e,
                                    result: 'AVAILABLE'
                                }
                            })
                            setData(mappedArray);
                        } else {
                            setData(prev => { return [...prev, {cn: cn, result:  'NOTAVAILABLE'}] })
                        }
                        
                    } catch (c) {
                        setData(prev => { return [...prev, { result: 'UNKNOWNERROR', error: `Something went wrong with this consignment ${c}` }] })
                    }
                } else {
                    setData(prev => { return [...prev, { cn: cn, result: 'WRONGENTRY' }] })
                }
                // setProgressBarArea(i + 1 / consignmentsIds.length + 1 * 100)
        } else if(consigneePhone || orderRef) {
                console.log(consigneePhone, orderRef);
                try {
                    dispatch(setLoading({ data: true }));
                    let cnResult = await SingleConsignmentTracking({ Consignments: cn, AccountNo: accounts, OrderNo: orderRef, PhoneNo: consigneePhone })
                    dispatch(setLoading({ data: false }));
                    if(cnResult.sts === true) {
                        if (cnResult.sts === true && cnResult.tracking_Details.length > 0) {
                            const mappedArray = cnResult.tracking_Details.map(e => {
                                return {
                                    ...e,
                                    result: 'AVAILABLE',
                                    
                                }
                            })
                            setData(mappedArray);
                        } else {
                            setData(prev => { return [...prev, {cn: consigneePhone || orderRef, result:  'NOTAVAILABLE'}] })
                        }
                       
                    } else if (cnResult.sts === 1) {
                        setData(prev => { return [...prev, {cn: consigneePhone || orderRef, result:  'ERROR', msg: cnResult.msg }] })
                    }
                } catch (e) {
                    setData(prev => { return [...prev, { result: 'UNKNOWNERROR', error: `Something went wrong ${e}` }] })
                }
        } 
    } 

    const onChange = (e) => {
        setcn(e.target.value);
    }

    const validateCnIdsLength = (value) => (value.split(',').filter(e => e.length > 0).length)

    return getSession('userInfo') && <section className="section">
        <div className="card" style={{ padding: 10 }}>
            {/* <div className="progress">
                <div className="progress-bar" role="progressbar" style={{ width: `${progressBarArea}%` }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div className="row mt-2">
                <label className={!cnIdsValidEntry && 'text-danger'}>
                    Total consignment count: {cnTotalEntries}
                </label>
                {!cnIdsValidEntry && <div className='text-danger'>
                    Maximum consignment tracking length is 50.
                </div>}
            </div> */}
            <div className="row mt-2">
                <div className="col-lg-3 col-sm-12">
                    <label>Consignment No</label>
                    <input type="text" placeholder='Consignment No' maxLength={15} onInput={processNumAndComma} className="form-control" value={cn} onChange={onChange} />
                </div>
                <div className="col-lg-3 col-sm-12">
                    <label>Consignee Phone No</label>
                    <input type="text" placeholder='03XXXXXXXXX' maxLength={11} onInput={processNum} className="form-control" value={consigneePhone} onChange={(e) => {
                        setConsigneePhone(e.target.value);
                    }} />
                </div>
                <div className="col-lg-3 col-sm-12">
                    <label>Order Ref No</label>
                    <input type="text" placeholder='12233Ref' maxLength={20} className="form-control" value={orderRef} onChange={(e) => {
                        setOrderRef(e.target.value);
                    }} />
                </div>
                <div className="col-lg-3 col-sm-12">
                    <button type="button" className="btn btn-primary" style={{ marginTop: '1.3rem' }} onClick={onSearch}>Search</button>
                </div>
            </div>
            {
                data.length > 0 && data.map((consignment, i) => (
                    <>
                        {
                            consignment.result === 'NOTAVAILABLE' &&
                            <div className='text-danger row solid-divider' key={i}>
                                {`Consignment not found against ${consignment.cn}.`}
                            </div>
                        }

                        {
                            consignment.result === 'ERROR' &&
                            <div className='text-danger row solid-divider' key={i}>
                                {`Error: ${consignment.cn} \n Message: ${consignment.msg}`}
                            </div>
                        }

                        {
                            consignment.result === 'UNKNOWNERROR' &&
                            <div className='text-danger row solid-divider' key={i}>
                                {`${consignment.error}`}
                            </div>
                        }

                        {
                            consignment.result === 'WRONGENTRY' &&
                            <div className='text-danger row solid-divider' key={i}>
                                {`Wrong Entry: ${consignment.cn}`}
                            </div>
                        }

                        {
                            consignment.result === 'AVAILABLE' &&
                            <CNInfo data={consignment} index={i} />
                        }

                    </>
                ))
            }
        </div>
    </section>
}

export default Tracking;




